import { createSelector } from 'reselect'

const oeqActivitySelector = createSelector(
	[
		state => state.creationTool.oeq,
	],
	oeqData => oeqData
)

export default oeqActivitySelector
